import React from 'react'

import { Skeleton, Stack, useMantineTheme } from '@affstore-ds/uikit'

export const GuestSkeleton = () => {
  const theme = useMantineTheme()

  return (
    <Stack
      style={{
        boxSizing: 'border-box',
        backgroundColor: theme.other.colors.white[0],
        borderRadius: theme.other.borderRadius[8],
        boxShadow: theme.other.shadows.s,
      }}
      gap={0}
      px={48}
      py={100}
      w="100%"
    >
      <Skeleton width={120} borderRadius={8} height={18} centered />

      <Skeleton width={232} borderRadius={100} height={36} mt={24} centered />

      <Skeleton width={43} borderRadius={100} height={20} mt={24} />
      <Skeleton width="100%" borderRadius={100} height={40} mt={6} />

      <Skeleton width={43} borderRadius={100} height={20} mt={24} />
      <Skeleton width="100%" borderRadius={100} height={40} mt={6} />

      <Skeleton width={154} borderRadius={100} height={20} mt={16} />

      <Skeleton width="100%" borderRadius={100} height={40} mt={24} />

      <Skeleton width={247} borderRadius={100} height={40} mt={24} />
    </Stack>
  )
}
